import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { ReactTitle } from 'react-meta-tags';
import { withTranslation } from 'react-i18next';
import FilterComponent from "../../utils/searchBar";
import { getRoles } from "../../../Redux/reducer/session";
import { MOD_CUSTOM, WRITE } from "../../../permissions/";
import { moduleAction, loadingHtml } from "../../utils/functions";
import * as ClientActions from "../../../Redux/actions/clientActions";
import { getClientList, getTotalElements } from "../../../Redux/reducer/clients";

//COMPONENTS IMPORTS
import MainTemplate from "../mainTemplate";
import Modal from "../../utils/customModal";
import TableClient from "../table/table-clients";
import BlankClient from "../provider/blankClient";

//STATIC IMPORTS
import UserAddIco from "../../../../static/images/user-add-black.svg";
import plusImage from "../../../../static/images/plus.svg";

export class ClientPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: true,
      componentReady: false,
      page: 1,
      data: null,
      totalSize: 0,
      sizePerPage: 10,
      firstLoad: false,
      customFilters: [],
    };
  }

  componentDidMount() {
    // Cargamos los Clientes
    const {
      actions: { getClientList },
    } = this.props;

    return getClientList().then(() => {
      this.setState({ modal: false, componentReady: true, firstLoad: true });
    });
  }

  componentWillUnmount() {

    this.props.actions.clearClientsList();
  }

  getFilters = () => {
    const { t } = this.props;
    return [
      { name: t("general.filters.name"), property: "name" },
      // { name: t("general.filters.cif"), property: "institution.cif", operator: "eq" },
      { name: t("general.filters.cif"), property: "cif" },
      { name: t("general.filters.identification"), property: "businessId" },
    ];
  }

  search = (searchProperty, searchTerm) => {
    const {
      actions: { getClientList },
    } = this.props;

    var actionFilters = [];

    if (searchTerm !== "") {
      actionFilters = [
        { property: `filter`, value: searchProperty },
        { property: `dataFilter`, value: searchTerm },
      ];
    }

    this.setState({ componentReady: false, modal: true, customFilters: actionFilters }, 
      () => {
        getClientList(0, 10, actionFilters).then(() => this.setState({ modal: false, componentReady: true }))
      }
    );
  };

  clientTable = () => {
    const { page, sizePerPage, firstLoad, customFilters } = this.state;
    const { clientes, totalElements } = this.props;

    if (firstLoad === true && (clientes !== null && clientes.length > 0)) {
      return (
        <TableClient
          data={clientes}
          page={page}
          history={this.props.history}
          customFilters={customFilters}
          getClientList={this.props.actions.getClientList}
          totalSize={totalElements}
          sizePerPage={sizePerPage}
        />
      );
    } else {
      return <BlankClient />;
    }
  };

  loadClients() {
    const { firstLoad } = this.state;
    const { clientes } = this.props;

    return firstLoad || (clientes !== null && clientes.length > 0) ? (
      this.clientTable()
    ) : (
        <BlankClient />
      );
  }

  render() {
    const { t, roles } = this.props;

    const filters = this.getFilters();

    return (
      <MainTemplate>
        <ReactTitle title={`${t('clients.meta.title')} - ${t('appName')}`} />
        <div className="header-title flex-element">
          <div className="title gest-client flex-element">
            <img src={UserAddIco} />
            <div className="client-gest">{t('clients.title')}</div>
          </div>
          <div className="actions flex-element">
            {moduleAction(roles, MOD_CUSTOM, WRITE) && (
              <Link to="/bscadministrator/clients/add" className="add-button flex-element">
                <p className="bsc-add-client">{t('clients.addClient')}</p>
                <img src={plusImage} />
              </Link>
            )}
            <div className="filter">
              <FilterComponent filter={filters} searchFnc={this.search} />
            </div>
          </div>
        </div>

        {this.state.componentReady === true ? this.loadClients() : null}
        <Modal show={this.state.modal}>{loadingHtml()}</Modal>
      </MainTemplate>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    clientes: getClientList(state),
    totalElements: getTotalElements(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ClientActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(ClientPage));
